import { ExpandedCmpService } from "@/vue/services/cmp/CmpModel";

export function categoryHasConsent(services: ExpandedCmpService[]): boolean {
  const indexOfFirstConsent = services.findIndex(
    service => service.consent.status
  );
  return indexOfFirstConsent !== -1;
}
